import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";

// React router
import { BrowserRouter, HashRouter } from "react-router-dom";

// Redux
import { Provider } from "react-redux";
import store from "store/inedx";

const root = ReactDOM.createRoot(
  document.getElementById("insurance-app-root") as HTMLElement
);
root.render(
  <Provider store={store}>
    {/* <BrowserRouter> */}
    <HashRouter>
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
    </HashRouter>
    {/* </BrowserRouter> */}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
